import { ElMessage, ElMessageBox } from "element-plus";
import { reactive, ref } from "vue";
import {
  queryApprovalTable,
  queryApprovalCount,
  submitApproval,
} from "@/api/approval";
import { postDownload } from "@/utils";

export default function useApprovalTable() {
  // 搜索条件ref
  const searchRef = ref(null);

  // 搜索条件表单
  const searchData = reactive({
    category: null,
    processStatus: null,
    createBy: null,
    type: null,
  });

  // 数据状态与菜单的映射
  const statusToMenu = reactive({
    pending: 1,
    processed: 2,
    myself: 3,
  });

  // 表格列配置
  const columns = ref([
    {
      label: "审批类型",
      prop: "category",
    },
    {
      label: "业务类型",
      prop: "typeName",
    },
    {
      label: "物料种类",
      prop: "categoryCount",
    },
    {
      label: "物料数量",
      prop: "materialCount",
    },
    {
      label: "审核人",
      prop: "dutyUserName",
    },
    {
      label: "创建人",
      prop: "createByName",
    },
    {
      label: "创建时间",
      prop: "createTime",
    },
    {
      label: "修改时间",
      prop: "updateTime",
    },
    {
      label: "状态",
      prop: "processStatus",
    },
  ]);

  // 表格遮罩
  const tableLoading = ref(false);

  // 表格数据
  const tableData = ref([]);

  // 默认选中的筛选条件
  const activeIndex = ref("pending");

  // 审核弹窗ref
  const approvalRef = ref(null);

  // 详情弹窗ref
  const approvalDetailRef = ref(null);

  // 表格删选类对象
  const menuList = ref([
    {
      index: "pending",
      label: "待处理",
    },
    {
      index: "processed",
      label: "已处理",
    },
    {
      index: "myself",
      label: "我发起的",
    },
  ]);

  // 待办已办发起数量对象
  const countObj = ref({
    completedQuantity: 0,
    initiateQuantity: 0,
    pendingQuantity: 0,
  });

  // 待办已办发起数量和菜单的映射
  const countToMenu = reactive({
    pending: "pendingQuantity",
    processed: "completedQuantity",
    myself: "initiateQuantity",
  });

  // 分页数据
  const pages = reactive({
    page: 1,
    size: 10,
    total: 0,
  });
  const handleSizeChange = (val) => {
    pages.size = val;
    pages.page = 1;
    getList();
  };
  const handleCurrentChange = (val) => {
    pages.page = val;
    getList();
  };
  const indexMethod = (index) => {
    // 计算连续序号
    return (pages.page - 1) * pages.size + index + 1;
  };
  const changeCategory = (val) => {
    searchData.type = null;
  };

  // 获取数据
  const getList = () => {
    tableLoading.value = true;
    queryApprovalTable({
      ...searchData,
      page: pages.page,
      limit: pages.size,
      approvalStatus: statusToMenu[activeIndex.value],
    })
      .then((res) => {
        tableData.value = res.data.records;
        pages.total = res.data.total;
      })
      .finally(() => {
        tableLoading.value = false;
        getApprovalCount();
      });
  };

  // 点击重置
  const handleReset = () => {
    searchRef.value?.resetFields();
    pages.page = 1;
    getList();
  };

  // 点击导出
  const handleExport = () => {
    ElMessageBox.confirm("确定导出审核数据吗？", "导出", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
    })
      .then(() => {})
      .catch(() => {});
  };

  // 提交审核
  const handleSubmitApproval = (row) => {
    approvalRef.value?.handleDialogOpen(row);
  };

  // 点击待办已办发起按钮
  const handleMenuSelect = (val) => {
    activeIndex.value = val;
    pages.page = 1;
    getList();
  };

  // 获取待办已办发起数量
  const getApprovalCount = () => {
    queryApprovalCount({}).then((res) => {
      countObj.value = { ...res.data };
    });
  };

  // 点击详情
  const handleDetail = (row) => {
    approvalDetailRef.value?.handleDialogOpen(row);
  };
  const handleRest = (row) => {
    ElMessageBox.confirm("确定要撤销审核吗？", "提醒", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        submitApproval({
          id: row.id,
          operateType: 5, // 1-发起审核、2-同意、3-驳回
          submitType: "2", //  1-发起审核、2-领导审核
          serialNumber: row.serialNumber,
          reason: "",
        }).then((res) => {
          if (res.code == "2000") {
            ElMessage.success("操作成功");
            getList();
          }
        });
      })
      .catch(() => {});
  };
  return {
    searchRef,
    searchData,
    columns,
    tableLoading,
    tableData,
    menuList,
    activeIndex,
    pages,
    handleSizeChange,
    handleCurrentChange,
    indexMethod,
    changeCategory,
    approvalRef,
    countObj,
    countToMenu,
    approvalDetailRef,
    getList,
    handleReset,
    handleExport,
    handleMenuSelect,
    handleSubmitApproval,
    handleDetail,
    handleRest,
  };
}
